export default "__VITE_ASSET__LEVNh6nC__"